import React from "react";


export const NotFound = () => (
    <h1>404 Not Found</h1>
);